<template>
  <div>
    <h2 class="step-name">Forecast Scanning</h2>

    <div class="step-section">
      <div class="form-group">
        <span class="form-group">
          <label for="wants_scanning_vs">
            Would you like to scan with VS in the coming season?
            <span class="glyphicon glyphicon-envelope" aria-hidden="true" data-toggle="tooltip" data-placement="top" title="Email might be generated"></span>
          </label>
          <comments field_name="wants_scanning_vs" :model="model.COMMENTS" :isReadOnly='isReadOnly'></comments>
        </span>

        <div class="radio">
          <label class="radio-inline">
            <input type="radio" v-model="model.wants_scanning_vs" :value="'Yes'"
                   :disabled="isReadOnly">Yes
          </label>

          <label class="radio-inline">
            <input type="radio" v-model="model.wants_scanning_vs" :value="'No'"
                   :disabled="isReadOnly">No
          </label>

          <label class="radio-inline">
            <input type="radio" v-model="model.wants_scanning_vs" :value="'Maybe'"
                   :disabled="isReadOnly">Maybe
          </label>
        </div>
        <span v-show="errors.has('wants_scanning_vs')" class="text-danger">
          {{ errors.has('wants_scanning_vs') }}
        </span>
      </div>
    </div>

    <div class="step-section">
      <h3>Scanning History</h3>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Date</th>
            <th>Description</th>
            <th>Quantity</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(sh, index) in model.CHARTS.scanning_table" :key="index"
            :class="getRowClass(model.CHARTS.scanning_table, 'Date', index)">

            <td class="text-left">{{ sh["Date"] }}</td>
            <td class="text-left">{{ sh["Description"] }}</td>
            <td class="text-left">{{ sh["Quantity"] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component'
import Comments from '@/components/OldComments'

export default {
  mixins: [ baseComponent ],
  components: {
    Comments,
  },
  data() {
    return {
      model: {
        wants_scanning_vs: "",
        CHARTS: {
          scanning_table: []
        }
      },
    }
  },
  methods: {
    toggleNotifications: function() {
      if (this.model.wants_scanning_vs == 'Yes' || this.model.wants_scanning_vs == 'Maybe') {
        this.toggleNotification({slug: 'forecast-scanning-details', value: true})
      } else {
        this.toggleNotification({slug: 'forecast-scanning-details', value: false})
      }
    },
  },
};
</script>
